<template>
    <div class="secondary-navigation px-3 px-md-5 py-3">
        <div class="d-flex gap-4 align-items-center">
            <a class="secondary-navigation-brand" href="/post-login">
                <img class="img-fluid" :src="'/assets/images/logo-on-light.svg'" alt="Kontent Kitani Logo" width="173" height="37">
            </a>
            <a href="/" class="d-none d-md-inline-flex badge bg-gray-300 text-dark text-decoration-none rounded-pill align-items-center caption gap-2">
                <Icon symbol="reply-fill"></Icon>
                <span>Back to Portal</span>
            </a>
        </div>
        <Dropdown class="profile-popper d-none d-md-flex" popper-class="v-popper--theme-navbar-main-auth">
            <div>
                <div class="hstack gap-4 p-3">
                    <div class="secondary-navigation-avatar hstack gap-3 align-items-center">
                        <Avatar 
                            :image-url="member?.logo?.url"
                            :text="member?.name"
                            size="default">
                        </Avatar>
                        <div>
                            <p class="subheading fw-bold mb-0">{{ member?.name }}</p>
                            <div v-if="member?.typeAlias === 'productionHouseMember'"><span class="subheading-upper text-muted">Production House</span></div>
                            <div v-else class="subheading-upper text-muted">Freelancer</div>
                        </div>
                    </div>
                    <Icon symbol="chevron-down" class="icon-l"></Icon>
                </div>
            </div>
            <template #popper>
                <div>
                    <div class="p-3">
                        <div class="secondary-navigation-avatar hstack gap-3 align-items-center">
                            <Avatar 
                                :image-url="member?.logo?.url"
                                :text="member?.name"
                                size="lg">
                            </Avatar>
                            <div>
                                <p class="subheading mb-0">{{ member?.name }}</p>
                                <div v-if="member?.typeAlias === 'productionHouseMember'" class="subheading-upper text-muted">Production House</div>
                                <div v-else class="subheading-upper text-muted">Freelancer</div>
                            </div>
                        </div>
                    </div>
                    <div class="list-group-main-nav-auth list-group list-group-flush">
                        <RouterLink
                            v-if="member?.approvalStatus?.name === 'Approved'"
                            :to="{
                                name: 'post-login-dashboard',
                            }"
                            class="list-group-item list-group-item-action hstack gap-3"
                        >
                            <Icon symbol="house-fill" class="text-muted"></Icon>
                            <span>Dashboard</span>
                        </RouterLink>
                        <RouterLink
                            v-if="member?.approvalStatus?.name === 'Approved'"
                            :to="{
                                name: 'my-portfolio-listing',
                            }"
                            class="list-group-item list-group-item-action hstack gap-3"
                        >
                            <Icon symbol="images" class="text-muted"></Icon>
                            <span>My Portfolio</span>
                        </RouterLink>
                        <RouterLink
                            v-if="member?.approvalStatus?.name === 'Approved'"
                            :to="{
                                name: 'my-service-listing',
                            }"
                            class="list-group-item list-group-item-action hstack gap-3"
                        >
                            <Icon symbol="stars" class="text-muted"></Icon>
                            <span>My Services</span>
                        </RouterLink>
                        <RouterLink
                            v-if="member?.approvalStatus?.name === 'Approved'"
                            :to="{
                                name: 'my-advertisement-listing',
                            }"
                            class="list-group-item list-group-item-action hstack gap-3"
                        >
                            <Icon symbol="megaphone" class="text-muted"></Icon>
                            <span>My Advertisement</span>
                        </RouterLink>
                        <RouterLink
                            :to="{
                                name: 'settings',
                            }"
                            class="list-group-item list-group-item-action hstack gap-3"
                        >
                            <Icon symbol="gear-fill" class="text-muted"></Icon>
                            <span>Settings</span>
                        </RouterLink>
                        <button
                            @click="broadcastPortalStore.logout(true)"
                            class="list-group-item list-group-item-action text-dark hstack gap-3"
                            type="button">
                            <Icon symbol="box-arrow-right" class="text-danger"></Icon>
                            <span class="text-danger">Logout</span>
                        </button>
                    </div>
                </div>
            </template>
        </Dropdown>

        <HamburgerButton
            v-if="!mdAndGreater"
            @click="toggle"
            :is-active="isActive"
        ></HamburgerButton>        
    </div>

</template>

<script setup lang="ts">
import { Icon } from '@/modules/core/components';
import { breakpointsBootstrapV5, useBreakpoints } from '@vueuse/core';
import { useMainNavOffcanvas } from './composables';
import HamburgerButton from './hamburger-button.vue';
import { Dropdown } from 'floating-vue';
import Avatar from '@/modules/core/components/avatar.vue';
import { storeToRefs } from 'pinia';
import { useBroadcastPortalAuthStore } from '../../store';

const { toggle, isActive } = useMainNavOffcanvas();

const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const mdAndGreater = breakpoints.greater('md');

const broadcastPortalStore = useBroadcastPortalAuthStore()

const { member } = storeToRefs(broadcastPortalStore);

</script>

<style lang="scss" scoped>

.secondary-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: $zindex-sticky;

    &-brand {
        max-width: 140px;
    }

    .profile-popper {
        .icon {
            transform: rotate(0);
            transition: transform .2s ease-in;
        }

        &.v-popper--shown {
            .icon {
                transform: rotate(180deg);
            }
        }
    }

    .secondary-navigation-avatar {
        .avatar.avatar-default {
            width: 2.25rem !important;
            border-radius: 0.5rem !important;
        }
    }

    @include media-breakpoint-up (md) {
        background-color: transparent;
        position: static;
    }
}
</style>